/*
  Create Your Piece — step 05 · Your Piece (Paper 10.36) and Edit / Summary
  (10.08). The dark band shows the piece front and back: side by side on
  desktop, one tile with a Front | Back toggle on mobile (Back first when
  there is an engraving). The reveal hands off to the product page: VIEW YOUR
  PIECE opens the chosen product (the chosen finish) with finish, engraving
  and font preloaded. The builder never adds to the bag. The edit sheet is
  reachable from any step and never restarts the flow on its own — its
  "Start over" asks first, like the top bar's.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  CYP.use(function (cyp) {
    var root = cyp.root;
    var rv = root.querySelector('[data-pb-step="5"]');
    var img = rv.querySelector('[data-rv-img]');
    var thumb = rv.querySelector('[data-rv-thumb]');
    var tiles = rv.querySelector('[data-rv-tiles]');
    var backBox = rv.querySelector('[data-rv-back]');
    var faceBtns = rv.querySelectorAll('[data-rv-face] [data-face-btn]');
    var cta = rv.querySelector('[data-rv-cta]');
    var sheet = root.querySelector('[data-pb-edit]');
    var sheetBox = sheet.querySelector('[data-edit-sheet]');
    var editCta = sheet.querySelector('[data-edit-cta]');
    var opener = null;
    var esc = cyp.esc;
    var sized = cyp.sized;

    function photoOf(s) { return cyp.imageFor(s, s.finish); }

    function delta(q) { return q.delta ? '+' + cyp.money(q.delta) : 'Included'; }

    function engravingText(s, short) {
      var q = cyp.quote(s);
      if (s.type === 'text') return (short ? '' : cyp.KINDS[s.kind] + ' · ') + s.value + (q && q.hasP ? ' · ' + delta(q) : '');
      if (s.type === 'crest') return (short ? 'Crest' : (s.crest === 'later' ? 'Crest · Sent after you order' : 'Crest · Uploaded next')) + (q && q.hasP ? ' · ' + delta(q) : '');
      if (s.type === 'none') return 'None';
      return '';
    }

    function breakdown(s, short) {
      var pc = cyp.pieceBy(s), q = cyp.quote(s);
      if (!pc || !q) return '';
      var parts = [(short ? cyp.settings.short[pc.family] : pc.name) + ' ' + cyp.money(q.base)];
      if (s.type === 'text') parts.push('Engraving ' + (q.delta ? '+' + cyp.money(q.delta) : 'included'), 'Font included');
      else if (s.type === 'crest') parts.push('Crest ' + (q.delta ? '+' + cyp.money(q.delta) : 'included'));
      else if (s.type === 'none') parts.push('No engraving');
      return parts.join(' · ');
    }

    /* ---------------------------------------------------------- reveal */
    function setFace(f) {
      tiles.dataset.face = f;
      faceBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-face-btn') === f ? 'true' : 'false'); });
      if (f === 'back') window.requestAnimationFrame(function () { cyp.fitBack(backBox); });
    }

    function renderReveal() {
      var s = cyp.state;
      var sp = cyp.sportBy(s.sport), pc = cyp.pieceBy(), fe = pc ? cyp.finishEntry() : null, q = cyp.quote();
      if (!pc || !q) return;
      var src = photoOf(s);
      if (src) {
        img.src = sized(src, 1100);
        thumb.src = sized(src, 300);
      }
      img.hidden = !src;
      backBox.innerHTML = cyp.backPlate(s);

      var rows = [
        ['Sport', esc(sp.name), 'rv-row--sport'],
        ['Piece', esc(pc.name)],
        ['Finish', esc(fe.label)],
        [s.type === 'text' || s.type === 'crest' ? 'Engraving · Back' : 'Engraving',
          '<span class="pb-d">' + esc(engravingText(s)) + '</span><span class="pb-m">' + esc(engravingText(s, true)) + '</span>']
      ];
      if (s.type === 'text') rows.push(['Font', esc(cyp.FONTS[s.font])]);
      rv.querySelector('[data-rv-rows]').innerHTML = rows.map(function (r) {
        return '<div class="rv-row' + (r[2] ? ' ' + r[2] : '') + '"><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>';
      }).join('');
      rv.querySelector('[data-rv-total]').textContent = cyp.money(q.total);
      var url = cyp.pdpUrl();
      cta.href = url || '#';
      var what = s.type === 'text' ? 'finish, engraving and font' : s.type === 'crest' ? 'finish and your crest choice' : 'finish';
      rv.querySelector('[data-rv-helper]').textContent = 'Opens the product page with your ' + what + ' preloaded. Price, stock and add to bag live there.';

      var front = sp && sp.sub ? sp.sub.replace(/\.$/, '') : 'The front';
      rv.querySelector('[data-rv-cap-front]').textContent = 'Front · ' + front;
      var backCap = s.type === 'text' ? [s.value, cyp.FONTS[s.font]] : s.type === 'crest' ? ['Crest', s.crest === 'later' ? 'Sent after you order' : 'Uploaded next'] : ['No engraving'];
      rv.querySelector('[data-rv-cap-back]').textContent = ['Back'].concat(backCap).join(' · ');
      window.requestAnimationFrame(function () { cyp.fitBack(backBox); });
    }

    function sentence() {
      var s = cyp.state, sp = cyp.sportBy(s.sport), pc = cyp.pieceBy(), fe = cyp.finishEntry(), q = cyp.quote();
      if (!pc || !q) return '';
      var e = s.type === 'text' ? ', engraved “' + s.value + '” in ' + cyp.FONTS[s.font] : s.type === 'crest' ? ', with your crest' : ', no engraving';
      return 'Your piece is ready: ' + sp.name + ' ' + pc.name + ' in ' + fe.label + e + '. Total ' + cyp.money(q.total) + '.';
    }

    cta.addEventListener('click', function (e) {
      var url = cyp.pdpUrl();
      if (!url) { e.preventDefault(); return; }
      cyp.track('view_piece_clicked', { destination: url });
      cyp.save();
    });
    rv.querySelector('[data-rv-edit]').addEventListener('click', function (e) { openSheet(e.currentTarget, 'reveal'); });
    faceBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-face-btn');
        if (tiles.dataset.face === f) return;
        setFace(f);
        cyp.announce(f === 'back' ? 'Showing the back, drawn as a template.' : 'Showing the front.');
      });
    });
    if (window.ResizeObserver) new ResizeObserver(function () { cyp.fitBack(backBox); }).observe(tiles);

    /* ---------------------------------------------------------- edit sheet */
    var RULES = {
      sport: 'Changing the sport clears the piece, and the finish only if the new piece does not offer it.',
      piece: 'Sport and finish are kept. Personalization is kept if the new piece supports the same model, and reset if it does not.',
      finish: 'Nothing else moves. The engraving, the font and the price all stay exactly as they are.',
      engraving: 'Switching to a crest clears the text — the builder asks before it does. Price updates, nothing else.',
      font: 'Your text is never cleared by a font change. Every font is included, so the price does not move either.'
    };

    function renderSheet() {
      var s = cyp.state, sp = cyp.sportBy(s.sport), pc = cyp.pieceBy(), fe = pc ? cyp.finishEntry() : null, q = cyp.quote();
      var rows = [];
      var lead = sp ? cyp.leadImage(sp) : null;
      rows.push({ f: 'sport', step: '1', label: 'Sport', value: sp ? sp.name : 'Next', thumb: lead ? '<img src="' + esc(sized(lead, 160)) + '" alt="" loading="lazy">' : '' });
      if (sp) {
        var src = fe ? photoOf(s) : null;
        rows.push({ f: 'piece', step: '2', label: 'Piece', value: pc ? pc.name : 'Next', thumb: src ? '<img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy">' : '' });
      }
      if (pc) rows.push({ f: 'finish', step: '3', label: 'Finish', value: s.finish && fe ? fe.label : 'Next', thumb: '<span class="pb-erow__swatch pb-erow__swatch--' + esc(s.finish || 'none') + '"></span>' });
      if (pc && s.finish) rows.push({ f: 'engraving', step: '4', label: 'Engraving', value: engravingText(s) || 'Next', thumb: '<span class="pb-erow__aa' + (s.type === 'text' ? ' pb-ff--' + s.font : '') + '">' + esc(s.type === 'text' && s.value ? s.value.slice(0, 3) : '—') + '</span>' });
      if (s.type === 'text') rows.push({ f: 'font', step: '4b', label: 'Font', value: cyp.FONTS[s.font], thumb: '<span class="pb-erow__aa pb-ff--' + s.font + '">Aa</span>' });
      sheet.querySelector('[data-edit-rows]').innerHTML = rows.map(function (r) {
        return '<li><button type="button" class="pb-erow" data-edit-go="' + r.step + '" data-edit-field="' + r.f + '">' +
          '<span class="pb-erow__thumb" aria-hidden="true">' + r.thumb + '</span>' +
          '<span class="pb-erow__main"><span class="pb-erow__label">' + r.label + '</span><span class="pb-erow__value">' + esc(r.value) + '</span></span>' +
          '<span class="pb-erow__rule">' + RULES[r.f] + '</span>' +
          '<span class="pb-erow__edit">Edit</span></button></li>';
      }).join('');
      var mobile = cyp.isMobile();
      sheet.querySelector('[data-edit-break]').textContent = breakdown(s, mobile);
      sheet.querySelector('[data-edit-total]').textContent = q && pc ? cyp.money(s.type ? q.total : q.base) : '';
      var url = pc && s.finish ? cyp.pdpUrl() : null;
      editCta.hidden = !url;
      if (url) editCta.href = url;
    }

    function focusables() {
      return Array.prototype.filter.call(sheetBox.querySelectorAll('button, a[href], [tabindex="0"]'), function (el) { return !el.hidden && el.offsetParent !== null; });
    }
    function openSheet(from, where) {
      opener = from || document.activeElement;
      renderSheet();
      sheet.hidden = false;
      document.documentElement.classList.add('pb-lock');
      cyp.track('edit_clicked', { field: 'summary', from_step: cyp.step, opened_from: where || 'reveal' });
      window.requestAnimationFrame(function () { sheetBox.focus(); });
    }
    function closeSheet(restore) {
      if (sheet.hidden) return;
      sheet.hidden = true;
      document.documentElement.classList.remove('pb-lock');
      if (restore !== false && opener && opener.focus) opener.focus();
    }

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-edit-close]')) { closeSheet(); return; }
      if (e.target.closest('[data-edit-restart]')) { closeSheet(false); cyp.requestStartOver(opener); return; }
      var row = e.target.closest('[data-edit-go]');
      if (row) {
        cyp.track('edit_clicked', { field: row.getAttribute('data-edit-field'), from_step: cyp.step });
        closeSheet(false);
        cyp.go(row.getAttribute('data-edit-go'));
      }
      if (e.target.closest('[data-edit-cta]')) {
        cyp.track('view_piece_clicked', { destination: editCta.getAttribute('href') });
        cyp.save();
      }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === sheetBox)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    cyp.on('open-edit', function (d) { openSheet(d && d.opener, d && d.from); });

    /* ---------------------------------------------------------- wiring */
    cyp.on('state', function () {
      if (cyp.step === '5') renderReveal();
      if (!sheet.hidden) renderSheet();
    });
    cyp.on('step', function (d) {
      closeSheet(false);
      if (d.step !== '5') return;
      var s = cyp.state;
      setFace(s.type === 'text' || s.type === 'crest' ? 'back' : 'front');
      renderReveal();
      cyp.announce(sentence());
      if (!cyp.session.revealSeen) {
        cyp.session.revealSeen = true;
        cyp.save();
        cyp.track('final_reveal_seen', {});
      }
    });
  });
})();
